import { configureStore } from "@reduxjs/toolkit";
import dataSplice from "./reducers/dataSplice";



export const store=configureStore({
    reducer:{
        data:dataSplice
    }
})